// extracted by mini-css-extract-plugin
export var icon = "_q6-0";